// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description = "A basic header widget.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Election seat finder",
  id: "election-seat-finder",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/election-seat-finder-vic-2026/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ImageQuoteConfigTool" */ "app/components/tools/ElectionSeatFinderConfigTool/ElectionSeatFinderConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ElectionSeatFinderConfigTool"]
  })
};

export default CONFIG;
